<template>
  <div class="container-fluid">
    <div class="wrapper">
      <!-- Header -->
      <div class="header__logo">
        <div class="container">
          <a href="/" class="header__logo-link">
            <img
              class="header__logo-image"
              style=""
              src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132"
              alt="Aozama"
            />
          </a>
        </div>
      </div>

      <!-- Container -->
      <div class="container home-offers">
        <div class="content">
          <div class="devices-category__content">
            <!-- Search Bar -->
            <div class="search-bar-form row m-0">
              <form class="" method="" id="">
                <!-- Search Bar Form -->
                <input
                  type="search"
                  class="search-bar-form__input form-control"
                  name="search"
                  placeholder="Busca un producto aquí"
                  v-model="search"
                  @change="setUrlSearch()"
                />

                <!-- Search Bar Dropdown -->
                <div class="search-bar-dropdown">
                  <div class="search-bar-dropdown__categories content-input">
                    <input type="hidden" name="categories" value="Categorias" />
                    <select
                      v-model="sortType"
                      @change="sortArticles()"
                      class="form-control search-bar-dropdown__select"
                      id=""
                    >
                      <option value="price-descending">
                        Precio - Alto a Bajo
                      </option>
                      <option value="price-ascending">
                        Precio - Bajo a Alto
                      </option>
                      <option value="best-selling">Más vendidos</option>
                      <option value="created-ascending">Lo más Nuevo</option>
                      <option value="created-descending">Menos Nuevo</option>
                    </select>
                  </div>
                </div>

                <!-- Search Bar Button -->
                <div class="search-bar-form__button base-button accept-btn">
                  BUSCAR
                </div>
              </form>
            </div>

            <!-- Product Category Slider -->
            <div
              class="
                product-category__sliders
                sliders--title
                row
                m-0
                padding--section
              "
            >
              <!-- Breadcrumb -->
              <div class="breadcrumb">
                <div class="col">
                  <ul class="breadcrumb__list">
                    <li><a href="/">Inicio</a></li>
                    <li class="active">{{ brand.name }}</li>
                  </ul>
                </div>
              </div>
              <div class="splide" v-show="categories.length">
                <div class="splide__track">
                  <ul class="splide__list kenwheeler">
                    <li class="splide__slide">
                      <a
                        href="javascript:void(0);"
                        class="splide__slide__container border-line"
                        @click="setCategoryId(null)"
                      >
                        <img
                          src="/images/offes-news-img/marcas/ct-todas-las-marcas.jpg"
                        />
                      </a>
                      <span @click="setCategoryId(null)">Todas</span>
                    </li>
                    <li class="splide__slide" v-for="category in categories">
                      <a
                        href="javascript:void(0);"
                        class="splide__slide__container border-line"
                        @click="setCategoryId(category.id)"
                      >
                        <img
                          src="{{category.icon ?? '/images/offes-news-img/subcategorias/ct-subcategoria-no-disponible.jpg' }}"
                        />
                      </a>
                      <span @click="setCategoryId(category.id)">{{
                        category.name
                      }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Available Models  -->
            <div
              class="
                available-models__list
                sliders--title
                row
                m-0
                padding--section
              "
            >
              <h3>Ofertas destacadas</h3>

              <div class="available-models__splide">
                <div class="available-models__track">
                  <ul class="available-models__list splide__list">
                    <li
                      class="splide__slide"
                      v-for="article in filteredArticles"
                    >
                      <a
                        href="/#!/product-detail/{{article.id}}"
                        class="splide__slide__container"
                      >
                        <img :src="article.image" />
                      </a>
                      <span>{{ article.name }}</span>
                      <label class="top-offers__price currency-price"
                        >RD$ {{ article.price | currency }}</label
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vue from "vue";
import router from "vue-router";

vue.use(router);

export default {
  name: "BrandList",
  referTo: "/brand-list",
  data: () => {
    return {
      service: {},
      brand_id: 1,
      category_id: null,
      categories: [],
      brand: [],
      articles: [],
      search: "",
      sortType: null,
    };
  },
  created() {
    this.brand_id = this.$route.params.id;
    this.getArticles();
    this.getBrand();
    this.getCategories();
    if (this.$route.query.sort) {
      this.sortType = this.$route.query.sort;
    }
    if (this.$route.query.q) {
      this.search = this.$route.query.q;
    }

    if (this.$route.query.category_id) {
      this.category_id = this.$route.query.category_id;
    }
  },
  methods: {
    getCategories() {
      this.$http
        .get(apiUrl + `/brands/${this.brand_id}/categories`)
        .then((response) => {
          this.categories = response.data;
          if (this.categories.length > 5) {
            this.$nextTick(() => {
              this.startSlick(".kenwheeler");
            });
          }
        });
    },
    sortArticles() {
      var querys = this.$route.query;
      querys.sort = this.sortType;
      this.$router.replace({ query: querys });
      switch (this.sortType) {
        case "price-descending":
          this.priceDescending();
          break;
        case "price-ascending":
          this.priceAscending();
          break;
        case "best-selling":
          this.bestSelling();
          break;
        case "created-ascending":
          this.createdAscending();
          break;
        case "created-descending":
          this.createdDescending();
          break;
        default:
          break;
      }
    },
    setUrlSearch() {
      var querys = this.$route.query;
      querys.q = encodeURIComponent(this.search);
      this.$router.replace({ query: querys });
    },
    getArticles() {
      this.$http
        .get(apiUrl + `/brands/${this.brand_id}/articles`)
        .then((response) => {
          this.articles = response.data;
        });
    },
    getBrand() {
      this.$http.get(apiUrl + `/brands/${this.brand_id}`).then((response) => {
        this.brand = response.data;
      });
    },
    setBrandId(id) {
      this.brand_id = id;
    },
    setCategoryId(id) {
      var querys = this.$route.query;
      querys.category_id = this.category_id;
      this.category_id = id;
    },
    priceAscending() {
      this.articles.sort((a, b) => (a.price * 1 > b.price * 1 ? 1 : -1));
    },
    priceDescending() {
      this.articles.sort((a, b) => (a.price * 1 < b.price * 1 ? 1 : -1));
    },
    bestSelling() {
      this.articles.sort((a, b) =>
        a.total_sold * 1 < b.total_sold * 1 ? 1 : -1
      );
    },
    createdAscending() {
      this.articles.sort((a, b) =>
        a.created_at * 1 > b.created_at * 1 ? 1 : -1
      );
    },
    createdDescending() {
      this.articles.sort((a, b) =>
        a.created_at * 1 < b.created_at * 1 ? 1 : -1
      );
    },
    startSlick(slickContainer) {
      $(slickContainer).slick({
        lazyLoad: "ondemand",
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
  },
  computed: {
    filteredArticles: function () {
      return this.articles.filter((article) => {
        var name = article.name.toLowerCase();
        var bySearch = name.match(this.search.toLowerCase());
        var brand = true;
        if (this.brand_id) {
          brand = this.brand_id == article.brand_id;
        }
        var category = true;
        if (this.category_id) {
          category = this.category_id == article.categories_id;
        }
        return bySearch && brand && category;
      });
    },
  },
};
</script>

<style lang="css" scoped>
img {
  max-width: 100%;
}
h1 {
  font-size: 26px;
}
.mr-20 {
  margin-right: 20px;
}

a {
  color: #213f99;
  border: none;
}
a:hover {
  text-decoration: underline;
  color: #213f99;
}
.container-fluid {
  padding: 0px;
}

/* Header */
.header__logo {
  background-color: #1e2d7d;
  max-height: 90px;
}
.header__logo a {
  display: block;
}

.header__logo-image {
  width: 180px;
}

.breadcrumb {
  text-transform: capitalize;
}

/* Breadcrum */
.breadcrumb__list {
  display: flex;
  background-color: transparent;
  list-style: none;
  padding: 8px 2px;
}
.breadcrumb__list li {
  float: left;
  font-size: 1.2em;
  margin-right: 15px;
  border-right: 1px solid #ccc;
  padding: 0 15px 0 0;
}
.breadcrumb__list li:last-child {
  border-right: 0px;
}
.breadcrumb__list li a {
  color: #000000;
}
.breadcrumb__list li.active {
  color: #1e2d7d;
}

.padding--section {
  padding: 25px 0;
}
.border-line {
  border: 1px solid #e7e7e7;
}

/* Button */
.base-button {
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  transition: all 0.3s;
}

.accept-btn {
  background-color: #38b449;
  color: #fff;
}
.accept-btn:hover {
  background-color: #1e2d7d;
}

.home-offer__content {
  padding-bottom: 50px;
}

.home-offer__sliders,
.search-bar-form {
  display: flex;
}

.search-bar-form {
  margin-bottom: 20px;
  margin-top: 40px;
}

.search-bar-form form {
  width: 100%;
}
.search-bar-form__input {
  width: 65%;
  float: left;
}
.search-bar-dropdown {
  width: 23%;
  float: left;
}
.search-bar-form__button {
  width: 10%;
  height: 42px;
  float: right;
}

/* Product Category Slide */
.sliders--title h3 {
  padding-bottom: 15px;
  margin: 20px 0;
  border-bottom: 1px solid #ddd;
}

.splide__list {
  display: flex;
}
.splide__slide {
  margin: 0 20px 0 0;
  text-align: center;
}

.splide__slide span {
  font-size: 16px;
  display: inline-block;
  color: #1e2d7d;
}
.splide__slide__container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 14px;
}

/* Avaible Models */
.available-models__list {
  flex-wrap: wrap;
}
.available-models__list .splide__slide {
  width: 265px;
  background: white;
  border: 1px solid #e7e7e7;
  padding: 15px;
  margin: 0px 10px 20px;
}

/* Top Slider */
.top-offers__sliders ul {
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  border-top: 1px solid #f5f5f5;
}

.top-offers__sliders ul li {
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
  margin: 0;
  padding: 15px;
}

.offer--title h1 {
  font-weight: bold;
}
.offer--title a {
  display: block;
  margin: 30px 0px 20px;
  text-align: right;
}
.offer--title .col-lg-2,
.offer--title .col-lg-10 {
  padding-left: 0px;
  padding-right: 0px;
}
.offer--cards__bg {
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 20px;
}
.offer--cards {
  width: 50%;
  min-height: 300px;
  text-align: center;
}
.offer--cards h3 {
  margin-top: 20px;
}
.offer--cards h4 {
  margin-top: 0px;
}
.offer--cards p {
  font-size: 18px;
  margin-top: 30px;
  color: #42494b;
}
.offer--cards a {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
.sign-price,
.currency-price {
  vertical-align: middle;
  color: #cf3917;
}
.currency-price {
  font-size: 24px;
  color: #cf3917;
  padding: 10px 0;
}
.cent-price {
  vertical-align: sub;
  margin-left: -5px;
  color: #cf3917;
}
</style>


// WEBPACK FOOTER //
// types-of-brands.vue?690a8cce